import React from 'react'

const CelebrityChefMenuMobile = () => {
    return (
        <div>CelebrityChefMenuMobile</div>
    )
}

export default CelebrityChefMenuMobile